import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const optionLocaleModule: LocaleModule = {
  name: "option",
  messages: { en: en, it: it },
};
